export default {
  title: 'Applications',
  fields: {
    id: 'ID',
    name: 'Nom',
    app_bundle_identifier: 'Identifiant du bundle',
    released: 'Publié',
    franchise: 'Marque',
    app_icon: "Icône de l'app",
    status: 'Statut',
    play_store_link: 'Lien Play Store',
    apple_store_link: 'Lien Apple Store',
    dynamic_link: 'Lien dynamique - QR Codes',
  },
  filters: {
    name: 'Nom',
    released: 'Publié',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Prêt à compiler',
    in_work: '🔧 En cours',
    in_review: '📝 En révision',
    rejected: '❌ Rejeté',
    released: '✅ Publié',
    deactivated: '🛑 Désactivé',
  },
  card: {
    overdue: 'En retard · {{time}}',
    copied: 'Copié dans le presse-papiers',
    released_tag: {
      both: '✅ Publié',
      ios: 'iOS publié',
      android: 'Android publié',
    },
    tags: {
      has_tech_issue: 'Problème technique',
    },
  },
  status_modal: {
    title: 'Mettre à jour le statut de publication',
    status_label: 'Statut',
    note_label: 'Note (optionnelle)',
    note_placeholder: 'Ajouter une note optionnelle pour ce changement de statut',
    tech_issue_checkbox: 'Il y a un problème technique',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  released: {
    yes: 'Oui',
    no: 'Non',
  },
  configured_status: {
    true: 'Oui',
    false: 'Non',
  },
  delete_confirmation: {
    title: "Supprimer l'application mobile",
    message: 'Êtes-vous sûr de vouloir supprimer cette application mobile ?',
    buttons: {
      confirm: 'Confirmer',
      cancel: 'Annuler',
    },
  },
};
